import { render, staticRenderFns } from "./BbField.vue.html?vue&type=template&id=694073fa&scoped=true&"
import script from "./BbField.component.js?vue&type=script&lang=vueJs&"
export * from "./BbField.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BbField.scoped.scss?vue&type=style&index=0&id=694073fa&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694073fa",
  null
  
)

export default component.exports